<script>
/**
 * Legacy route: /dashboard/loja-perfeita/campanhas/:id/config
 * Redirects to the list with openSetup query so the same campaign setup modal opens.
 */
export default {
    name: 'LojaPerfeitaCampaignConfig',
    created() {
        const id = this.$route.params.id
        this.$router.replace({
            name: 'lojaPerfeita',
            query: { openSetup: String(id) },
        })
    },
    render(h) {
        return h('div')
    },
}
</script>
